import React from "react";

export default function Specilization() {
  return (
    <div className="bg-gray-50 p-10 rounded-lg shadow-lg mx-5 my-20">
      <h2 className="text-center  mx-20 my-8 text-4xl font-bold tracking-wide uppercase bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500 text-transparent bg-clip-text">
        Key Areas of Specialization
      </h2>
      <div className="flex my-20 flex-col md:flex-row gap-8">
        <div className="flex-1 bg-gradient-to-r from-blue-500 to-green-500 text-white p-6 rounded-lg shadow-md">
          <h3 className="text-2xl font-edusa font-bold mb-4">
            Warehousing and Logistics Expertise
          </h3>
          <p className="text-lg font-poppins font-bold">
            Our specialization in warehousing and logistics includes providing
            manpower for inventory management, order fulfillment, and
            distribution.
          </p>
        </div>

        <div className="flex-1 bg-gradient-to-r from-purple-500 to-pink-500 text-white p-6 rounded-lg shadow-md">
          <h3 className="text-2xl  font-edusa font-bold mb-4">
            Production Staffing and Support
          </h3>
          <p className="text-lg font-poppins font-bold">
            We offer specialized staffing solutions for production facilities,
            with a focus on maintaining high productivity levels and ensuring
            adherence to quality standards. Our personnel are trained to manage
            diverse production environments effectively.
          </p>
        </div>
        <div className="flex-1 bg-gradient-to-r from-yellow-500 to-caribbeangreen-500 text-white p-6 rounded-lg shadow-md">
          <h3 className="text-2xl font-edusa font-bold mb-4">
            Hospitality Staffing Excellence
          </h3>
          <p className="text-lg font-poppins font-bold">
            Our expertise in the hospitality sector enables us to deliver
            exceptional service staff who enhance guest experiences in
            Logistics, warehouse, and other venues. We understand the nuances of
            hospitality and ensure our staff uphold the highest standards of
            service.
          </p>
        </div>
      </div>
    </div>
  );
}
